
export function getValueFromNestedObject(object: any, flatKey: string) {
    if (!flatKey) return undefined;
    const keys = flatKey.split('.');
    return keys.reduce((obj, key) => {
        return obj && obj[key] !== 'undefined' ? obj[key] : undefined;
    }, object);
}
